import { render, staticRenderFns } from "./create-special-new.vue?vue&type=template&id=7b9f2a8d"
import script from "./create-special-new.vue?vue&type=script&lang=js"
export * from "./create-special-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports